import MpSourceRedirecter from './MpSourceRedirecter';
import LayoutCustom from './Components/UI/Layout/LayoutCustom';

const LayoutWrapper = (props) => {
  return (
        <>
            <MpSourceRedirecter /> 
            <LayoutCustom {...props} />
        </>
    );
};
export default LayoutWrapper;
